"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotDueDate = exports.isDueDate = exports.isDueDateNotOverdue = exports.isDueDateOverdue = exports.isDueDateOnOrAfter = exports.isDueDateOnOrBefore = exports.isDueDateAfter = exports.isDueDateBefore = exports.isNotDueDateEmpty = exports.isDueDateEmpty = void 0;
const date_fns_1 = require("date-fns");
const comparisons_1 = require("../../comparisons/comparisons");
const fns_1 = require("../../utils/fns");
const date_1 = require("../../utils/date");
const isDueDateEmpty = (_filterValue) => {
    return (fieldValue) => {
        return !(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.to_date.date);
    };
};
exports.isDueDateEmpty = isDueDateEmpty;
exports.isNotDueDateEmpty = (0, comparisons_1.invert)(exports.isDueDateEmpty);
const isDueDateBefore = (filterValue) => {
    const startOf = (0, date_fns_1.startOfDay)(filterValue);
    return (fieldValue) => {
        if (!(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.to_date.date)) {
            return false;
        }
        const dueDate = fieldValue.to_date.date;
        return (0, date_fns_1.isBefore)(dueDate, startOf);
    };
};
exports.isDueDateBefore = isDueDateBefore;
const isDueDateAfter = (filterValue) => {
    const endOf = (0, date_fns_1.endOfDay)(filterValue);
    return (fieldValue) => {
        if (!(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.to_date.date)) {
            return false;
        }
        const dueDate = fieldValue.to_date.date;
        return (0, date_fns_1.isAfter)(dueDate, endOf);
    };
};
exports.isDueDateAfter = isDueDateAfter;
const isDueDateOnOrBefore = (filterValue) => {
    return (fieldValue) => {
        if (!(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.to_date.date)) {
            return false;
        }
        const dueDate = (0, date_fns_1.startOfDay)(fieldValue.to_date.date);
        const filterDate = (0, date_fns_1.startOfDay)(filterValue);
        return (0, date_fns_1.isSameDay)(dueDate, filterDate) || (0, date_fns_1.isBefore)(dueDate, filterDate);
    };
};
exports.isDueDateOnOrBefore = isDueDateOnOrBefore;
const isDueDateOnOrAfter = (filterValue) => {
    return (fieldValue) => {
        if (!(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.to_date.date)) {
            return false;
        }
        const dueDate = (0, date_fns_1.startOfDay)(fieldValue.to_date.date);
        const filterDate = (0, date_fns_1.startOfDay)(filterValue);
        return (0, date_fns_1.isSameDay)(dueDate, filterDate) || (0, date_fns_1.isAfter)(dueDate, filterDate);
    };
};
exports.isDueDateOnOrAfter = isDueDateOnOrAfter;
const isDueDateOverdue = () => {
    return (fieldValue, field, userPreferences) => {
        var _a;
        if (!((_a = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.to_date) === null || _a === void 0 ? void 0 : _a.date)) {
            return false;
        }
        let dueDate = fieldValue.to_date.date;
        let completedDate = fieldValue.status_is_completed && !!fieldValue.status_updated_on
            ? fieldValue.status_updated_on
            : (0, date_1.getNow)(userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.timezone.value);
        if (!fieldValue.to_date.include_time) {
            dueDate = (0, date_fns_1.startOfDay)(dueDate);
            completedDate = (0, date_fns_1.startOfDay)(completedDate);
        }
        return (0, date_fns_1.isBefore)(dueDate, completedDate);
    };
};
exports.isDueDateOverdue = isDueDateOverdue;
exports.isDueDateNotOverdue = (0, comparisons_1.invert)(exports.isDueDateOverdue);
const isDueDate = (filterValue) => {
    return (fieldValue) => {
        if (filterValue.lower === null || filterValue.upper === null) {
            return false;
        }
        if ((fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.from_date.date) &&
            (fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.to_date.date) &&
            fieldValue.from_date.date > fieldValue.to_date.date) {
            return (0, fns_1.isBetween)(fieldValue.from_date.date, filterValue.lower, filterValue.upper, filterValue.bounds);
        }
        return (!!(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.to_date.date) &&
            (0, fns_1.isBetween)(fieldValue.to_date.date, filterValue.lower, filterValue.upper, filterValue.bounds));
    };
};
exports.isDueDate = isDueDate;
exports.isNotDueDate = (0, comparisons_1.invert)(exports.isDueDate);
